import type { TranslationTag } from '@ps/web-core-intl';

import type { Breadcrumb } from '../types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => ({ ...defaultState }),
  dataLoadSuccess: (state: State, payload: Breadcrumb | TranslationTag): State => ({
    ...state,
    breadcrumb: payload,
    isLoading: false,
    preloaded: true
  }),
  dataLoadFailed: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    preloaded: true,
    errorCode: payload
  }),
  breadcrumbsRequested: (state: State) => ({
    ...state,
    isLoading: true
  })
};
